module.exports = __webpack_public_path__ + "img/material_handling.ba7e6fb2.png";